<!--  -->
<template>
  <div class="m_adv">
    <mb-header theme='dark'></mb-header>

    <div class="header">
      <router-link to="/m_index" class="content_btn">
        <img src="../assets/logo.png" alt class="logo">
      </router-link>
    </div>
    <div class="main">
      <ul class="main_ul">
        <li>
          <!-- <h3 class='main_h3'>中国大陆客户分布图</h3> -->
          <img src="../assets/blo8.jpg" alt>
        </li>
        <li>
          <!-- <h3 class='main_h3'>主要客户集团</h3> -->
          <img src="../assets/blo5.png" alt>
        </li>
        <li>
          <div class="text">
            <p class="weight">在于对人才 / 产品 / 服务三项品质的坚持</p>
            <p>企业的竞争就是人才的竞争</p>
            <p>人才是最重要的资源</p>
            <p>规范运作 · 确保质量 · 信誉承诺</p>
            <p>服务是宗旨</p>
            <p>用户满意是企业永恒的追求</p>
          </div>
        </li>
      </ul>
      <div class="get_btn">
        <router-link to="/m_contentUS" class="content_btn">联系我们</router-link>
      </div>
    </div>
    <mb-fotter></mb-fotter>
    <back-top></back-top>
  </div>
</template>

<script>
import mbFotter from "../components/moblie-fotter.vue";
import mbHeader from "../components/moblie-header.vue";
import backTop from "../components/back-top.vue";


export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    mbFotter,
    mbHeader,
    backTop,
  },

  data() {
    //这里存放数据
    return {};
  },

  //监听属性 类似于data概念
  computed: {},

  //监控data中的数据变化
  watch: {},

  //方法集合
  methods: {},

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
};
</script>
<style lang='less' scoped>
.m_adv {
  background: #fff9dd;
  min-height: 100vh;
  .header {
    width: 100%;
    .logo {
      margin: 0.3rem 0 0 0.3rem;
      width: 35%;
    }
  }
  .main {
    padding-bottom: 0.3rem;

    .main_ul {
      width: 90%;
      margin: 0.9rem auto 0;
      li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.2rem;
        img {
          width: 100%;
        }
        .main_h3 {
          width: 68%;
          padding: 0.38rem 0;
          border-top: 1px solid rgba(5, 65, 131);
          border-bottom: 1px solid rgba(5, 65, 131);
          font-size: 0.78rem;
          color: rgba(5, 65, 131, 1);
          text-align: center;
          font-weight: 800;
          margin-bottom: 0.6rem;
        }
        .text {
          width: 100%;
          p {
            text-align: center;
            color: #054183;
            font-size: 0.28rem;
            &.weight {
              font-weight: 800;
            }
          }
        }
      }
    }
    .get_btn {
      text-align: center;
      width: 40%;
      height: 0.84rem;
      background: #0583c9;
      line-height: 0.84rem;
      color: #fff;
      border-radius: 6px;
      margin: 0.1rem auto 0.3rem;
      font-size: 0.36rem;
      font-weight: normal;
      .content_btn {
        color: #fff;
      }
    }
  }
}
</style>